export class EmployeeOption {
  constructor(data) {
    this.id = data.id;
    this.label = data.fullName;
  }
}
